<template>
  <div class="toggle-header" :class="params.headerClass">
    {{ params.headerName }}
    <div v-if="params.enableToggle" class="toggle ml-4 mr-2 mb-2">
      <tooltip :value="tooltipValue" :disabled="!tooltipValue">
        <v-switch
          :input-value="initialValue"
          :disabled="params.isDisabled()"
          class="mr-2 pt-0"
          primary
          dense
          hide-details
          @change="toggle($event)"
        >
          <template v-slot:label>
            {{ params.toggleLabel }}
            <v-icon size="1.8rem" right>{{ params.toggleIcon }}</v-icon>
          </template>
        </v-switch>
      </tooltip>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  computed: {
    initialValue() {
      return this.params.initialValue(this.params) || false;
    },
    tooltipValue() {
      return this.params.tooltipValue(this.params) || '';
    },
  },
  methods: {
    toggle(checked) {
      this.params.onToggle(checked);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.toggle-header {
  display: flex;

  .v-icon--right {
    margin-left: 0.2rem;
  }
}

::v-deep {
  .toggle {
    label {
      margin-bottom: 0.4rem;
    }
  }
}
</style>
